module.exports = __webpack_public_path__ + "static/media/welcome-left.df72358b.png";